<h2>User info</h2>

<table class="table table-sm" *ngIf="user$ | async as user">
	<thead>
		<th>Name</th>
		<th>Value</th>
	</thead>
	<tbody>
		<tr *ngFor="let item of user | keyvalue">
			<th>{{ item.key }}</th>
			<td>{{ item.value }}</td>
		</tr>
	</tbody>
</table>
